import { render } from "./RoutingConfig.vue?vue&type=template&id=714275cf&scoped=true&ts=true"
import script from "./RoutingConfig.vue?vue&type=script&lang=ts"
export * from "./RoutingConfig.vue?vue&type=script&lang=ts"

import "./RoutingConfig.vue?vue&type=style&index=0&id=714275cf&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714275cf"]])

export default __exports__